import React from 'react';
import { Radar, RadarChart, PolarGrid, Legend, PolarAngleAxis, PolarRadiusAxis, Tooltip, ResponsiveContainer } from 'recharts';

function RadarGraph(props) {

  // Check if custom dimemsions are non-zero
  const customDim = [];
  props.data.map((dim,index)=>(
    customDim.push(dim.Custom)
  ));
  const customDimSum = customDim.reduce((partialSum, a) => partialSum + a, 0);


  const colors = {
    custom: '#8884d8',
    proximity: '#82ca9d',
    reference: '#e31c79',
  }

  const CustomTooltip = ({ active, payload }: any) => {
    // console.log(payload)
    if (active && payload && payload.length) {
      return (
        <div className='bg-white bg-opacity-90 border-gray-200 border-2  px-5 py-3 rounded-sm'>
          <div className='flex-inline'>
            <p className='text-sm font-bold mb-2'>{payload[0].payload.subject}</p>
            <div className='flex-inline text-right'>
              <div className='flex justify-end'>            
                <p className={`font-semibold text-sm text-[${colors.custom}]`}>Custom&#160;</p>
                <p className='text-sm text-[#8884d8]'>: {payload[0].payload.Custom}</p>
              </div>
              {payload[0].dataKey==='Closest' && 
              <div className='flex justify-end'>            
                <p className='font-semibold text-sm text-[#82ca9d]'>Proxmitiy&#160;</p>
                <p className='text-sm text-[#82ca9d]'>({payload[0].name.length<40?
                payload[0].name: payload[0].name.slice(0,38)+'...'}): {payload[0].payload.Closest}</p>
              </div>
              }
              {(payload[1] && payload[1].dataKey==='Closest') && 
              <div className='flex justify-end'>            
                <p className='font-semibold text-sm text-[#82ca9d]'>Proxmitiy&#160;</p>
                <p className='text-sm text-[#82ca9d]'>({payload[1].name.length<40?
                payload[1].name: payload[1].name.slice(0,38)+'...'}): {payload[1].payload.Closest}</p>
              </div>
              }

              {(payload[1] && payload[1].dataKey==='Reference') && 
              <div className='flex justify-end'>            
                <p className='font-semibold text-sm text-[#e31c79]'>Reference&#160;</p>
                <p className='text-sm text-[#e31c79]'>({payload[1].name.length<40?
                payload[1].name: payload[1].name.slice(0,38)+'...'}): {payload[1].payload.Closest}</p>
              </div>
              }
              {payload[2] && 
              <div className='flex justify-end'>            
                <p className='font-semibold text-sm text-[#e31c79]'>Reference&#160;</p>
                <p className='text-sm text-[#e31c79]'>({payload[2].name.length<40?
                payload[2].name: payload[2].name.slice(0,38)+'...'}): {payload[2].payload.Reference}</p>
              </div>
              }
            </div>
          </div>
        </div>
      );
    }
  
    return null;
  };

  return (
    <div className='flex-inline lg:-mr-0'>

      {!props.hideLegend &&
      <div className='h-20 w-full'>
      <ResponsiveContainer width="100%" height={10}>
      <RadarChart cx="50%" cy={350} outerRadius="80%" height="100%" data={props.data}>
        <PolarGrid />
        <PolarAngleAxis dataKey="subject" />
        <PolarRadiusAxis angle={30} domain={[0, 100]} />

        <Radar name={props? props.refShowName: "Reference"}
                dataKey="Reference"
              //  stroke="#e31c79"
                fill={props.refShow ? "#e31c79" : "#FFFFFF"}
                fillOpacity={props.refShow ? 0.3 : 0} />


        {customDimSum!==0 &&
        <Radar name="Custom" dataKey="Custom" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6}
                onMouseEnter={(e)=>{console.log(e)}}
                onMouseDown={(e)=>{console.log(e)}}
                onMouseLeave={()=>{console.log('bye bye!')}}/>
        }

        {props.returnProximity[0].show_name!=='' &&
        <Radar name={props ? props.showName: ''} dataKey="Closest" stroke="#82ca9d" fill="#82ca9d" fillOpacity={0.6} />
        }
        <Legend layout="vertical"
                verticalAlign="top"
                align="right"
                iconSize={16}
                iconType="circle"
                wrapperStyle={{
                  left: 197,
                  top: -1,
                  paddingBottom: 0,
                }} />
      </RadarChart>
      </ResponsiveContainer>
      </div>
      }

      <div className='w-full'>
      <ResponsiveContainer width="100%" height={500}>
      <RadarChart cx="51.5%" cy={220} outerRadius="72%" height="100%" data={props.data}
                  margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
        <PolarGrid />
        <PolarAngleAxis dataKey="subject"
                        fontSize={props.labelFontSize ? props.labelFontSize : 16}
                        />
        <PolarRadiusAxis angle={30} domain={[0, 100]} />

        {/* <Radar name={props? props.refShowName: "Reference"}
                dataKey="Reference"
              //  stroke="#e31c79"
                fill={props.refShow ? "#e31c79" : "#FFFFFF"}
                fillOpacity={props.refShow ? 0.3 : 0} /> */}


        {customDimSum!==0 &&
        <Radar name="Custom" dataKey="Custom" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6}
                onMouseEnter={(e)=>{console.log(e)}}
                onMouseDown={(e)=>{console.log(e)}}
                onMouseLeave={()=>{console.log('bye bye!')}}/>
        }

        {props.returnProximity[0].show_name!=='' &&
        <Radar name={props ? props.showName: ''} dataKey="Closest" stroke="#82ca9d" fill="#82ca9d" fillOpacity={0.6} />
        }

        {props.refShow &&
        <Radar name={props? props.refShowName: "Reference"}
                dataKey="Reference"
              //  stroke="#e31c79"
                fill="#e31c79"
                fillOpacity={0.3} />
        }

        {!props.hideLegend && 
        <Tooltip content={<CustomTooltip payload={props.data} />}
                 position={props.showName.length>=30 && { x: -150 }}
                //  allowEscapeViewBox={{ x: false, y: true }}
                // position={{ x: -150 }}
                //  viewBox={{ x: -100, y: 0, width: 400, height: 400 }}
         />
        }
      </RadarChart>
      </ResponsiveContainer>
      </div>
    </div>
  );
}

export default RadarGraph;
